import { useState } from 'react'
import useWindowResize from 'beautiful-react-hooks/useWindowResize'

const MOBILE_MAX_WIDTH = 991

function getCurrentWidth() {
  try {
    return window.innerWidth
  } catch {
    return 0
  }
}

export default function useIsMobile() {
  const [width, setWidth] = useState(getCurrentWidth())
  const onWindowResize = useWindowResize()

  onWindowResize(() => {
    const currentWidth = getCurrentWidth()
    if (currentWidth !== width) {
      setWidth(currentWidth)
    }
  })

  return width <= MOBILE_MAX_WIDTH
}